import { render, staticRenderFns } from "./TableHD.vue?vue&type=template&id=71ca6444&"
import script from "./TableHD.vue?vue&type=script&lang=js&"
export * from "./TableHD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports